<template>
  <svg
    :class="{ up: up, down: !up }"
    xmlns="http://www.w3.org/2000/svg"
    width="5"
    height="4"
    viewBox="0 0 5 4"
  >
    <g id="Group_2563" data-name="Group 2563" transform="translate(-0.5 0.467)">
      <path
        id="Polygon_21"
        data-name="Polygon 21"
        d="M2.5,0,5,4H0Z"
        transform="translate(0.5 -0.467)"
        fill="#0c9"
      />
    </g>
  </svg>
</template>

<script>
export default {
  name: 'PositionChange',
  props: ['up'],
}
</script>

<style lang="scss" scoped>
.down {
  transform: rotate(180deg);
  path {
    fill: $dusk;
  }
}
</style>
